/* eslint-disable */
import { api, cancelRequests } from '@/services';
import Vuetify from '@/plugins/vuetify';
import Vue from 'vue';

export default {
  setDraggedItem({ commit }, payload) {
    commit('SET_DRAGGED_ITEM', payload);
  },
  async atualizarCard({ dispatch }, payload) {
    await api.put(`/gestao-tarefas/${payload._id}`, payload);

    dispatch('fetchCards');
  },
  async getUsuariosTrust({ commit }) {
    const response = await api.get('/usuario/trust');

    commit('SET_USUARIOS_RESPONSAVEIS_TRUST', response.data);

    return response;
  },
  async getUsuariosComex({ commit }) {
    const response = await api.get('/usuario/comex/usuarios');

    commit('SET_USUARIOS_RESPONSAVEIS_COMEX', response.data);

    return response;
  },
  async fetchListaResponsaveis({ commit }) {
    const listaResponsaveis = await api.get('/usuario/emails/domain').then(response => response.data);

    commit('SET_USUARIOS_RESPONSAVEIS', listaResponsaveis);
  },
  async fetchCards({ commit }, payload) {
    const cards = await api.get(`/gestao-tarefas/listar/${payload}`);
    commit('SET_CARDS', cards.data);
  },
  async parar() {
    cancelRequests();
  },
  async fetchCard({ commit, state }, payload) {
    if (state.hasInterval) {
      const card = await api.get(`/gestao-tarefas/${payload._id}`);
      if (!card.data.responsavel) {
        card.data.responsavel = {
          ANALISTA: {},
          ASSISTENTE1: {},
          ASSISTENTE2: {},
        };
      }
      commit('SET_CARD', card.data);
    }
  },
  async duplicaCard({ dispatch }, payload) {
    const cardJaFoiCriado = await api.get(`/gestao-tarefas/duplicata/${payload.posicaoCard}/${payload.idCard}`);

    if (cardJaFoiCriado.data) {
      Vue.$toast.clear();

      return Vue.$toast.warning(Vuetify.framework.lang.t('$vuetify.cardDuplicadoMensagemVerificacao'));
    }

    await api.post('/gestao-tarefas/criar', payload);

    dispatch('fetchCards');
  },
  async updateObservationCard(context , payload) {
    const response = await api.put(`/gestao-tarefas/card/${payload.cardId}/observacao/${payload.id}`, payload.data);
    return response;
  }
};
